import { useNotifications } from 'modules/notification/hooks/useNotifications';
import { realtimerAudiences } from 'realtimer/realtimerAudiences';
import { useAuthStore } from 'shared/hooks/stores/useAuthStore';
import { useRealtimer } from 'shared/hooks/useRealtimer';

export const useNotificationRealtimer = () => {
  const expertId = useAuthStore((state) => state.user?.expertId)!;
  const { refetchNotifications } = useNotifications();

  useRealtimer(realtimerAudiences.notificationInserted(expertId), () => {
    refetchNotifications();
  });
};
